import { TranslocoService } from '@jsverse/transloco';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,
    //  TranslocoDirective
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class App {
  //protected title = 'Q8 Oils Business';

  constructor(private translocoService: TranslocoService) {}


}
